/**
 * Klinik yöneticisine sunulacak hazır tema renk paletleri.
 * Her palette sadece bir primary HEX tutar; geri kalan shade'ler
 * themeUtils.generatePalette() ile otomatik üretilir.
 */
const CLINIC_PALETTES = [
  { id: "blue",      label: "Mavi",        hex: "#2563eb" },
  { id: "indigo",    label: "İndigo",      hex: "#4f46e5" },
  { id: "violet",    label: "Mor",         hex: "#7c3aed" },
  { id: "fuchsia",   label: "Fuşya",       hex: "#c026d3" },
  { id: "rose",      label: "Pembe",       hex: "#e11d48" },
  { id: "red",       label: "Kırmızı",     hex: "#dc2626" },
  { id: "orange",    label: "Turuncu",     hex: "#ea580c" },
  { id: "amber",     label: "Amber",       hex: "#d97706" },
  { id: "emerald",   label: "Yeşil",       hex: "#059669" },
  { id: "teal",      label: "Turkuaz",     hex: "#0d9488" },
  { id: "cyan",      label: "Camgöbeği",   hex: "#0891b2" },
  { id: "sky",       label: "Gök Mavisi",  hex: "#0284c7" },
  { id: "slate",     label: "Gri-Mavi",    hex: "#475569" },
  { id: "zinc",      label: "Koyu Gri",    hex: "#52525b" },
];

export const DEFAULT_PRIMARY = "#2563eb";

export default CLINIC_PALETTES;
